import React from "react";
import { Link } from "react-router-dom";
import {
    FaLinkedinIn,
    // FaFacebookF,
    // FaInstagram,
    FaArrowRight,
    FaMapMarkerAlt,
    FaEnvelope,
    // FaPhoneAlt
} from "react-icons/fa";

import logo from "../yperlogo.png";
import "../CSS/footer.css";

function Footer() {
    return (
        <footer className="footer">

            {/* ================= MAIN FOOTER ================= */}
            <div className="container">

                <div className="footer-main">

                    {/* BRAND */}
                    <div className="footer-brand-section">

                        <img
                            src={logo}
                            alt="YperSystem Solution"
                            className="footer-logo"
                        />

                        <h3>YperSystem Solution</h3>

                        <p>
                            Building innovative, scalable, and user-friendly
                            software solutions that help businesses grow,
                            automate, and succeed with technology.
                        </p>

                        <div className="footer-social">

                            <a
                                href="https://www.linkedin.com/company/ypersystem-solutions"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YperSystem Solutions LinkedIn"
                            >
                                <FaLinkedinIn />
                            </a>

                            {/* <a href="#" aria-label="Facebook">
                                <FaFacebookF />
                            </a>

                            <a href="#" aria-label="Instagram">
                                <FaInstagram />
                            </a> */}

                        </div>

                    </div>


                    {/* QUICK LINKS */}
                    <div className="footer-column">

                        <h4>Industries</h4>

                        <ul>
                            <li>
                                <Link to="/industries/manufacturing">Manufacturing</Link>
                            </li>

                            <li>
                                <Link to="/industries/healthcare">Healthcare</Link>
                            </li>

                            <li>
                                <Link to="/industries/education">Education</Link>
                            </li>

                            <li>
                                <Link to="/industries/realestate">RealEstate</Link>
                            </li>
                            <li>
                                <Link to="/industries/hospitality">Hospitality</Link>
                            </li>
                        </ul>

                    </div>


                    {/* SERVICES */}
                    <div className="footer-column">

                        <h4>Our Services</h4>

                        <ul>
                            <li>
                                <Link to="/services/custom-software">
                                    Custom Software
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/erp-business">
                                    ERP & Business
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/web-application">
                                    Web Applications
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/cloud-solutions">
                                    Cloud Solutions
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/mobile-application">
                                    Mobile Applications
                                </Link>
                            </li>
                        </ul>

                    </div>


                    {/* AI SOLUTIONS */}
                    <div className="footer-column">

                        <h4>AI Solutions</h4>

                        <ul>
                            <li>
                                <Link to="/ai/video-creator">
                                    AI Video Creator
                                </Link>
                            </li>

                            <li>
                                <Link to="/ai/image-creator">
                                    AI Image Creator
                                </Link>
                            </li>

                            <li>
                                <Link to="/ai/business-solutions">
                                    AI Business Solutions
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/digital-marketing">
                                    Digital Marketing
                                </Link>
                            </li>

                            <li>
                                <Link to="/services/database-solutions">
                                    Database Solutions
                                </Link>
                            </li>
                        </ul>

                    </div>


                    {/* CONTACT */}
                    <div className="footer-column footer-contact">

                        <h4>Get In Touch</h4>

                        <div className="footer-contact-item">
                            <FaMapMarkerAlt />
                            <span>
                                India
                            </span>
                        </div>

                        <div className="footer-contact-item">
                            <FaEnvelope />
                            <span>
                                ypersystem@gmail.com
                            </span>
                        </div>

                        {/* <div className="footer-contact-item">
                            <FaPhoneAlt />
                            <span>
                                +91 XXXXX XXXXX
                            </span>
                        </div> */}

                        <Link
                            to="/contactus"
                            className="footer-contact-button"
                        >
                            Let's Talk
                            <FaArrowRight />
                        </Link>

                    </div>

                </div>


                {/* ================= FOOTER BOTTOM ================= */}

                <div className="footer-divider"></div>

                <div className="footer-bottom">

                    <p>
                        © {new Date().getFullYear()} YperSystem Solution.
                        All Rights Reserved.
                    </p>

                    {/* <div className="footer-bottom-links">
                        <Link to="/privacy-policy">
                            Privacy Policy
                        </Link>

                        <Link to="/terms">
                            Terms & Conditions
                        </Link>
                    </div> */}

                    <div className="footer-designed">
                        <span>Align Technology with Growth</span>
                        <span>Designed by</span>

                        <a
                            href="https://www.linkedin.com/company/ypersystem-solutions"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            @YperSystem
                            <FaLinkedinIn />
                        </a>
                    </div>

                </div>

            </div>

        </footer>
    );
}

export default Footer;